import ja from 'element-ui/lib/locale/lang/ja'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: "AI分析レポート",
        train: "研修カリキュラム",
        loading: "読み込み中...",
        loadingError1: "読み込みできませんでした",
        loadingError2: "申し訳ございません。時間をおいて再度お試しください。",
    },
    login: {
        loginAndRegister: '登録/ログイン',
        registerAndLogin: 'ログイン/登録',
        userLogin: 'ユーザーログイン',
        title: '携帯番号と電子メールで設定したアカウントは、それぞれ独立しています。アカウントのタイプご注意ください。',
        mobileLogin: '電話',
        emailLogin: 'メールボックス',
        email: 'E-mail',
        loginBtn: 'ログイン',
        autoLogin: '次回は自動ログインする',
        retransmission: '{item}秒後再度送ります',
        formList: [
            {
                label: '電話番号を入力してください',
                placeholder: '確認コードを取得する',
            },
            {
                label: '確認コード',
                placeholder: '確認コードを入力してください',
            },
            {
                label: 'メールを入力',
            },
        ],
        btn: {
            submit: '新しいアカウントを作成する',
            title: '実際の情報は非常に重要です。慎重に記入してください',
        },
        rule: {
            phone: {
                requiredMsg: '電話番号の形式が正しくありません',
                patternMsg: '電話番号が登録されていません。新しいアカウントを作成してください',
            },
            authCode: {
                requiredMsg: '確認コードエラー、再度入力してください',
            },
            email: {
                requiredMsg: 'メールアドレスの形式が正しくありません',
                patternMsg: 'メールアドレスが登録されていません。新しいアカウントを作成してください',
            },
        },
        codeSuccess: '認証コードが送信されました。受信箱を確認してください。',
        success: '送信できました',
        error: '送信できませんでした',
        loginSuccess: 'ログインできました',
        account: {
            accountTitle: 'ログイン',
            registerTitle: 'ログイン',
            resetTitle: 'パスワードを設定する',
            password: 'パスワード',
            placeholder: 'パスワードを入力してください',
            codeLogin: '認証コードでログイン',
            accountLogin: 'パスワードでログイン',
            forgotPassword: 'パスワードを忘れましたか？',
            registerTips:[
                'アカウントをお持ちでないですか？', 
                'ログイン', 
                'アカウントは既に存在します',
                '新規登録',
            ],
            checkRule: [
                '8～20文字',
                '少なくとも1つの大文字を含めてください',
                '少なくとも1つの小文字を含めてください',
                '少なくとも1つの数字を含めてください', 
                'パスワードが一致しません'
            ],
            errorTips: [
                'パスワードが間違っています', 
                'ログインに失敗しました', 
                'アカウントが存在しません'
            ],
            reset:[
                'パスワードをリセットする', 
                "次へ",
                '新しいパスワードは前回のパスワードと同じにできません', 
                'スキップ',
                'パスワードの設定が成功しました'
            ],
            setPasswordTips:'パスワードは8～20文字で構成され、大文字、小文字、および数字を含める必要があります。',
            confirmPassword: "新パスワードの確認",
        },
        switchButton: 'パスワードでログイン',
        switchButton1: '認証コードでログイン',
        loginTips: '未登録のアカウントでログインすると、自動的に登録されます。',
        otherLogin: 'その他のログイン方法',
        newEmailLogin: 'メールログイン',
        newPhoneLogin: '携帯電話番号ログイン',
        bindLineTips:'または',
        bindEmail: '連携したメールアドレスでログイン',
        bindPhone: '連携した電話番号でログイン',
        bindAndContinue: "連携して続行",
        bind: "連携する",
        bindEmailTitle: 'メールアドレスを連携',
        bindEmailTips1: "{item} のメール情報が見つかりません",
        bindEmailTips2: "请绑続行するにはメールを連携してください定邮箱以继续使用账号",
        bindEmailTips3: "未連携です。連携後はメールでログインや再設定が可能です。",
        boundTitle: '以前登録したことがありますか？',
        boundCenterTitle1:'新規ユーザーの場合',
        boundCenterTips1:'アカウントを作成して開始',
        boundCenterTitle2:'登録済みアカウントがある場合',
        boundCenterTips2:'既存のアカウントを連携して、過去のデータを同期できます',
        boundCenterTips3:'登録済みのアカウントを連携してください',
        boundCenterTips4:'おすすめ',
        boundCenterTips5:'{item} を既存アカウントに連携',
        boundCenterTips6:'連携後、データとレポートは同期されます',
        boundButton1: '{item} でアカウント作成',
        boundButton2: '既存アカウントと連携',
        phoneCode:"SMS認証ログイン",
        phonePassword:"携帯番号とパスワードでログイン",
        emailCode:"メール認証ログイン",
        emailPassword:"メールアドレスとパスワードでログイン",
        accountDoesNotExist:"このアカウントは登録されていません。メール認証コード、または{item}でログインして登録を完了してください。",
        toRegister:"新規登録",
        bindNow: "今すぐ連携",
        bindError:[
            '連携に失敗しました',
            '連携を解除しました',
            '連携解除に失敗しました',
            '認証に失敗しました',
            '認証に失敗しました、アカウント情報を取得できません',
            '連携に成功しました',
            'アカウントが存在しません。登録済みのアカウントを連携してください。',
            '連携に失敗しました。このアカウントはすでに{item}アカウントと連携済みです [{nickname}]。',
            'アカウントとして認証登録済みのため、連携解除はできません',
            'アカウントが存在しません。認証コードを使用してログインおよび登録してください',
        ],
        accountSecurity: {
            faceBook:'Facebookアカウント',
            google: 'Googleアカウント',
            isBind: '未連携',
            dialogTitle: '連携を解除しますか？',
            dialogCenter: '{item} の連携を解除すると、このアカウントへのログインに使用できなくなります。',
            bindFailure:'連携に失敗しました',
            bindFailureTips: 'お客様の{item}アカウントは、以下のアカウントに既に連携されています。現在のアカウントに連携を変更したい場合は、まず以下のアカウントにログインして連携を解除してください。',
            returnButton:'確認して戻る'
        },
        bindEmailError: [
            "このメールアドレスは既に登録されています。別のメールアドレスを入力してください。"
        ],
    },
    register: {
        mobileRegister: '電話',
        emailRegister: 'メールボックス',
        enroll: '携帯番号がログインされました',
        enrollEmail: '電子メールが登録されている',
        search: '検査',
        title: 'IDログイン、データレポートをクラウドストレージし、便利にチェックできる',
        needRead: {
            agree: 'を読み、同意します',
            privacy: '「ユーザープライバシー契約」',
        },
        register: 'ログイン',
        check: '「ユーザープライバシー契約」を確認してください',
        newUser: '新規ユーザーログイン',
        form: {
            labelList: ['ユーザー名', '* 性別', '* 身長', '* 年齢'],
        },
        placeholder: ['ユーザー名を入力してください', '身長を入力してください', '年齢を入力してください'],
        unit: ['SI', 'BS', '歳'],
        sexOptions: {
            male: '男性',
            female: '女性',
        },
        btn: '提出',
        rules: {
            metricheight: ['許容される身長の範囲は2ft3in-6ft7inです。再度入力してください'],
            heightMsg: ['許容される身長の範囲は70〜200cmです。再度入力してください'],
            ageMsg: ['測定可能な年齢範囲は10〜99歳ですので、再度入力してください'],
            agePointMsg: ['整数以外の数値を入力しました：年齢は整数のみです。正しい年齢を入力してください'],
        },
        success: '登録完了',
        userMessage: 'ユーザーネームを入力してください',
        verify: '4桁の確認コードを入力してください',
        errorMsg: '身長入力には小数点は許されません。再入力してください',
        abnormalMsg: '登録異常',
    },
    model: {
        loading: 'モデル生成中。少々お待ちください',
        modelLoading: 'モデル読み込み中',
        tabPane: [
            {
                title: 'ディープリアリティテクノロジー',
                msg: '体の局所的な詳細を3次元スキャンで正確に収集し、胴回り測定のミリメートルレベルの精度を確保し、フィットネス後の体型が明確に表示されます。',
            },
            {
                title: 'BDA体組成アルゴリズム',
                msg: 'Visbodyは、最先端の体組成測定システムであるBDAアルゴリズムを利用して体組成を測定します。この計算方法は、体の体積に基づいており、肥満による健康リスクをより正確に評価できます。',
            },
            {
                title: 'エラーを引き起こす要因',
                msg: '衣服が緩んでいる、体に異物が付着している場合、ある程度の誤差が発生します。最も正確なデータを取得したい場合は、タイツを着用するか、体に着る服の量を減らしてください。',
            },
            {
                title: 'レポートエントリ',
                msg: '今後レポートをチェックできるように、Webページをブックマークすることをお勧めします。このレポートを後でメールボックスに送信して保存することもできます。',
            },
        ],
        collect: ['本Webページをブックマークすることをお勧めします。', '今後レポートをチェックできるように、'],
        know: '分かりました',
        reminder: [
            'ご注意',
            '3Dモデルが生成されました。左右にスワイプして、モデルを回転させることができます。',
            'レポートが生成されました。[レポート確認]ボタンをクリックしてレポートを確認できます。',
            '姿勢評価に失敗しました。体組成レポートを確認してください。',
            '体組成評価に失敗しました。姿勢評価レポートを確認してください。',
            '測定に失敗しました。デバイスに再度測定してください〜~',
            '体組成に失敗しましたので、デバイスに再度測定してください〜~',
            '姿勢評価に失敗しました。デバイスに再度測定してください〜~',
        ],
        btn: {
            viewReport: 'レポートを確認する',
            bodyReport: '体組成レポートを確認する',
            postureReport: '姿勢レポートを確認する',
            lastReport: '前回のレポートを確認する',
            loading: '読み込み中...',
        },
    },
    report: {
        btn: {
            download: 'レポートをダウンロードする',
            send: 'レポートを送信します',
            report: 'レポート',
        },
        reportSuccess: 'レポートが生成されました',
        tabPane: {
            labelList: ['測定時間', '測定項目', '体組成', '姿勢評価', '肩の機能'],
        },
        sendEmail: 'メールボックスに送信する:',
        requiredMsg: 'メールアドレスを入力してください',
        patternMsg: '有効なメールアドレスを入力してください',
        send: '送信する',
        download: 'レポートをダウンロードする',
        sendReport: 'レポートを送信する',
    },
    sidebar: {
        successMsg: {
            sex: '性別を変更できました',
            height: '身長を変更できました',
            age: '年齢を変更できました',
        },
        logOut: 'サインアウト',
        personal: 'パーソナルセンター',
        cut: '言語/単位の切り替え',
        changeSort: '製品レポートを切り替える',
        setPassword: 'パスワードの設定/変更',
        accountSecurity: 'アカウントとセキュリティ',
        describe: '* 製品モデルを切り替えた後、対応する製品モデルのすべての測定レポートが表示されます。',
        describeBtn: '製品モデルを切り替えた後、その製品モデルの下の最新の測定レポートが表示されます。',
        descReport: '製品レポートの切り替えができました',
        unit: ['SI (kg, cm)', 'BS (ft, in, lb)'],
        read: {
            reading: 'をお読みください',
            privacy: '「ユーザープライバシー契約」',
        },
        setting: '設定',
        form: {
            labelList: ['携帯電話番号', '単位', '言語', 'ユーザー名', '性別', '身長', '年齢'],
        },
        placeholder: ['ユーザー名を変更する', '性別の変更', '身長変更', '年齢変更'],
        btn: {
            cancelBtn: 'キャンセル',
            accomplishBtn: '終了',
            confirmBtn: '決定',
        },
        dialog: [
            '性別は体組成測定の重要な基準の1つです。変更した後測定するデータは以前のデータとは異なります。変更するかを確認してください。',
            '身長は体組成測定の重要な基準の1つです。変更した後測定するデータは以前のデータとは異なります。変更するかを確認してください。',
            '年齢は体組成測定の重要な基準の1つです。変更した後測定するデータは以前のデータとは異なります。変更するかを確認してください。',
        ],
        rules: {
            metricheight: ['範囲以内（2ft3in-6ft7in）の身長を入力してください'],
            heightMsg: ['範囲以内（70〜200cm）の身長を入力してください'],
            ageMsg: [
                '範囲以内（10〜99歳）の年齢を入力してください',
                '整数以外の数値を入力しました：年齢は整数のみです。正しい年齢を入力してください',
            ],
        },
        heightMsg: '身長を再度選択してください',
        ageMsg: '年齢を再度選択してください',
        ModelBinding: '誰かがスキャンしたようです。もう一度測定してください。',
        ReportEmpty: {
            title: '関連する測定レポートがありません',
            desc: 'Visbody 3D測定ウィザードが見つかりました、測定を行ってください！',
        },
    },
    modelBinding: {
        desc: '誰かがスキャンしたようです。もう一度測定してください。',
    },
    reportEmpty: {
        title: '関連する測定レポートがありません',
        desc: 'Visbody 3D測定ウィザードが見つかりました、測定を行ってください！',
        descS30: 'Visbody-S30 3D測定ウィザードが見つかりました、測定を行ってください！',
        descM30: 'Visbody-M30 3D測定ウィザードが見つかりました、測定を行ってください！',
    },
    userInfo: {
        height: '身長：',
        age: '年齢：',
        unit: '歳',
        weight: '体重',
    },
    mass: {
        title: '体組成評価の概要',
        titles: '体組成',
        springFrame: '',
        massFrame: '当日の測定データはありません',
        contrast: 'レポートを選らんで比較する',
        contrastReport: '比較レポートを選択する',
        noRecord: '記録なし',
        score: '点',
        status: '現在の体組成の状態',
        WT: '体重',
        PBF: '体脂肪率',
        endSymbol: '。',
        measure: {
            value: '測定値',
            standardRange: '標準範囲',
            comparedWithLastLime: '前回との比較',
            comparedNet: '前回との比較',
            current: '今回の測定点数',
            WT: '体重',
            FFM: '除脂肪体重',
            BFM: '体脂肪',
            LM: '筋肉量',
            TBW: '総水分量',
            SM: '骨格筋',
            PROTEIN: 'タンパク質',
            TM: '無機塩',
            BMR: '基礎代謝',
            WHR: 'W/H比',
            BMI: 'BMI',
            PBF: '体脂肪率',
            VFG: '内臓脂肪レベル',
            unit: 'kg',
            BMRUnit: 'kcal/d',
        },
        explain: [
            {
                title: '体重',
                msg: '体重とは身体の水分・タンパク質・無機塩及び体脂肪の合計を指します。',
            },
            {
                title: '除脂肪体重',
                msg: '除脂肪体重とは体重から脂肪を差し引いたものを指します。',
            },
            {
                title: '体脂肪',
                msg: '体脂肪とは皮下脂肪・内臓脂肪及び筋肉間脂肪の合計を指します。',
            },
            {
                title: '筋肉量',
                msg: '筋肉量は、人体の除脂肪体重、骨格筋、平滑筋、心筋で構成されている。',
            },
            {
                title: '総水分量',
                msg: '身体の水分は人体を形成する成分の中で最も多く、体重の50～70%を占めています。身体の水分は人体の細胞と体液の中に分布し、大部分が筋肉細胞の中に存在しています。',
            },
            {
                title: '骨格筋',
                msg: '骨格筋は横紋筋とも呼ばれ、骨格の筋肉に付着している筋肉の一つで、ここで計算されるのは骨格筋の含有量となります。',
            },
            {
                title: 'タンパク質',
                msg: 'タンパク質とは窒素を含む固体物質で、体内のすべての細胞に存在し、細胞の構成に関与しています。また、筋肉量の主な成分です。',
            },
            {
                title: '無機塩',
                msg: '人体は有機物/無機物/水分で構成されており、体内の無機物を無機塩とよんでいます。無機塩は身体の約5%の重量を占めています。',
            },
            {
                title: '基礎代謝',
                msg: '基礎代謝とは身体が起き安静している状況の中で、運動・植物・神経の緊張、外界温度の変化などの影響を受けない際の一日に消費する総エネルギー量のことを指します。',
            },
            {
                title: 'W/H比',
                msg: 'ウエストヒップ比とは腰囲と臀囲の比率で、中心性肥満度を判定するのに重要な指標を指します。',
            },
            {
                title: 'BMI',
                msg: 'BMIとは主に外観的肥満度を評価するのに用いられ、人間の体がどれだけ太っているか、あるいは痩せているかを示す指標として、国際的によく使われています。',
            },
            {
                title: '体脂肪率',
                msg: '体脂肪率とは脂肪が体重に占める割合を指します。',
            },
            {
                title: '内臓脂肪レベル',
                msg: '内臓脂肪の程度は、隠れ肥満かどうかを判断する重要な指標です。',
            },
            {
                title: '細胞内液',
                msg: '細胞内液：身体の細胞に含まれる体液で、原形質の基本成分です',
            },
            {
                title: '細胞外液',
                msg: '細胞外液：通常、血漿および血管と組織細胞の間の間質液を含む細胞外体液を指す',
            },
            {
                title: '代謝年齢',
                msg: '代謝年齢とは、体とその健康に関連した代謝機能のパフォーマンスを指します。',
            },
            {
                title: '細胞外水分比率',
                msg: '細胞外水分比率とは、総体水分（TBW）に占める細胞外水分（ECW）の割合を指し、一般に ECW/TBW で表されます。体液バランスの状態を評価する重要な指標です。',
            },
        ],
        segment: {
            fat: '局部脂肪',
            muscle: '局部筋肉',
            right: '右',
            left: '左',
            standard: '標準',
            lowStandard: '低標準',
            superStandard: '高標準',
            peel: '(風袋)',
        },
    },
    shape: {
        title: '体格評価概要',
        titles: '姿勢評価',
        status: '現在の体調',
        suggest: 'アドバイス',
        possibility: '、存在',
        models: {
            front: '正面図',
            left: '左面図',
            right: '右面図',
            top: '裏',
            low: 'やや低い',
            high: 'やや高い',
            normal: '正常',
        },
        item: {
            deviate: '測定値',
            result: '説明',
            normal: '正常',
			keAbnormal: '異常の疑いあり',
            abnormal: '異常',
            head: '頭部の前傾',
            headSlant: '頭部の後傾',
            roundShoulderLeft: '左側巻き肩',
            roundShoulderRight: '右側巻き肩',
            highLowShoudler: 'なで肩',
            pelvis: '骨盆の前後移動',
            leftKneeCheck: '左膝の評価',
            rightKneeCheck: '右膝の評価',
            leg: '脚タイプ',
            leftLeg: '左脚：',
            rightLeg: '右脚：',
        },
        explain: [
            {
                title: '頭部の前傾',
                msg: '左側の耳の点と首の中心を結ぶ線と側面の正中線の間の夾角',
            },
            {
                title: '頭部の後傾',
                msg: '前頭部の中点と首の中心を結ぶ線と正面の中線との間の角度',
            },
            {
                title: '左側巻き肩',
                msg: '背中の左側の一番高い点を結ぶ線と肩の接線との間の夾角',
            },
            {
                title: '右側巻き肩',
                msg: '背中の右側の一番高い点を結ぶ線と肩の接線との間の夾角',
            },
            {
                title: 'なで肩',
                msg: '背中の左右の肩点間の垂直距離',
            },
            {
                title: '骨盆の前後移動',
                msg: '左側の首の中心点、寛骨点、足首点を結ぶ線の夾角',
            },
            {
                title: '左膝の評価',
                msg: '左側の寛骨点、膝関節、足首点を結ぶ三点線の夾角',
            },
            {
                title: '右膝の評価',
                msg: '右側の寛骨点、膝関節、足首点を結ぶ三点線の夾角',
            },
            {
                title: '脚タイプ',
                msg: '左右の脚の正面の寛骨点、膝関節、足首点を結ぶ線の夾角',
            },
            {
                title: '骨盤前傾/後傾',
                msg: '左右の上前腸骨棘と恥骨結合で形成される面と、地面に対する垂直線との角度。'
            },
            {
                title: '脚長差異',
                msg: '左右の臀溝の最も低い点と地面の高さの差。'
            }
        ],
        exception: [
            {
                title: '左に偏る',
                abnormal: '',
            },
            {
                title: '右に偏る',
                abnormal: '',
            },
            {
                title: '左が高い',
                abnormal: '',
            },
            {
                title: '右が高い',
                abnormal: '',
            },
            {
                title: '骨盤変位(後)',
                abnormal: '',
            },
            {
                title: '骨盤変位(前)',
                abnormal: '',
            },
            {
                title: '左膝過伸展',
                abnormal: '',
            },
            {
                title: '左膝の前屈',
                abnormal: '',
            },
            {
                title: '右膝過伸展',
                abnormal: '',
            },
            {
                title: '右膝の前屈',
                abnormal: '',
            },
            {
                title: 'K型レッグ',
                abnormal: '',
            },
            {
                title: 'D型レッグ',
                abnormal: '',
            },
            {
                title: 'X型レッグ',
                abnormal: '',
            },
            {
                title: 'がに股',
                abnormal: '',
            },
        ],
    },
    newshape: {
        explain: [
            {
                msg: '耳と身体の重心線との垂直距離',
            },
            {
                msg: '両耳を結ぶ線と水平線のなす角度',
            },
            {
                msg: '左肩峰と重心線との垂直距離',
            },
            {
                msg: '右肩峰と重心線との垂直距離',
            },
            {
                msg: '両側の頸部基部と肩峰を結ぶ線の差異',
            },
            {
                msg: '股関節と身体の重心線との垂直距離',
            },
            {
                msg: '矢状面における足関節、左膝関節下1cmおよび股関節のなす角度',
            },
            {
                msg: '矢状面における足関節、右膝関節下1cmおよび股関節のなす角度',
            },
            {
                msg: '冠状面における両側の股関節、膝関節および足関節間の角度',
            },
        ],
        item: {
            pelvis: '骨盤前傾',
        },
    },
    girth: {
        title: '各部位の周囲長',
        present: '（今回）',
        noHistory: 'データなし',
        tpl: [
            {
                title: '頸部周囲長',
                key: 'neckGirth',
            },
            {
                title: '左上腕部周囲',
                key: 'leftUpperArmGirth',
            },
            {
                title: '右上腕部周囲',
                key: 'rightUpperArmGirth',
            },
            {
                title: 'バスト',
                key: 'bustGirth',
            },
            {
                title: 'ハイウエスト',
                key: 'waistGirth',
            },
            {
                title: 'ミッドウエスト',
                key: 'midWaistGirth',
            },
            {
                title: 'ヒップ',
                key: 'hipGirth',
            },
            {
                title: '左大腿部周囲',
                key: 'leftThighGirth',
            },
            {
                title: '左大腿中央部周囲',
                key: 'leftMidThighGirth',
            },
            {
                title: '左大腿部最小外周',
                key: 'leftMinThighGirth',
            },
            {
                title: '右大腿部周囲',
                key: 'rightThighGirth',
            },
            {
                title: '右大腿中央部',
                key: 'rightMidThighGirth',
            },
            {
                title: '右大腿部最小外周',
                key: 'rightMinThighGirth',
            },
            {
                title: '左足ふくらはぎ周長',
                key: 'leftCalfGirth',
            },
            {
                title: '右足ふくらはぎ周囲',
                key: 'rightCalfGirth',
            },
            {
                title: 'ロウウエスト',
                key: 'lowWaistGirth',
            },
        ],
    },
    shoulder: {
        title: '頸肩部機能',
        model: {
            val: '測定値',
            scope: '最大活動位置',
            diff: '前回との比較',
        },
        normal: '明らかな異常は検出されませんでした',
        normalAll: '肩の機能に明らかな異常はまだ見られません',
        conclusion: '結論',
        analyse: '分析：',
        suggest: 'アドバイス：',
        cause: '具体的な原因は専門家にさらなる検査を依頼して確認してください。',
    },
    reportTips: {
        title: "このレポートを削除してもよろしいですか？削除後は復元できません。",
        confirm: "削除",
        success: "レポートは削除されました",
        partial: "レポートは削除されました。一部のデータ同期に失敗しました。管理者にお問い合わせください。",
        failed: "削除に失敗しました。しばらくしてから再度お試しください",
        btnMsg: 'OK',
        alaryTips: 'このレポートは管理者により削除されました。次のレポートへジャンプします',
    },
    saveQr: {
        title: 'Visbody 3Dボディテストレポート',
        btnMsg: '画像を長く押して携帯電話に保存します。',
        tips: '保存できないことに気づいたら、【設定】に行って該当権限を開いてください。',
    },
    share: {
        title: '以下のリンクをコピーして共有してください',
        btnMsg: 'コピー',
    },
    "waist": {
    "title": "腰腹囲測定",
    "hou": "後",
    "qian": "前"
  },
  "yao_wei_1": "腰部",
  "yao_bu_fen_shu": "腰部スコア",
  "waist_fen": "点",
  "yao_wei": "腰囲",
  "yao_wei_jian_ti_ji": "腰囲間の体積",
  "yao_tun_bi": "W/H比",
  "lun_kuo_fen_xi": "輪郭分析",
  "bei_bu": "背部",
  "tunbu": "臀部",
  "bei_bu_ti_ji": "背部体積",
  "zheng_chang_fan_wei": "正常範囲：",
  "shang_ci": "前回 ",
  "ben_ci": "今回 ",
  "gupen": {
    "zheng_chang": "正常",
    "qian_qin_yan_chang": "前傾異常",
    "qian_qin_yi": "前傾リスク",
    "hou_qin_yi": "後傾リスク",
    "hou_qin_yan_chang": "後傾異常",
    "zuo_chang_yan_chang": "左脚長異常",
    "zuo_chang_yi": "左脚長リスク",
    "you_chang_yi": "右脚長リスク",
    "you_chang_yan_chang": "右脚長異常"
  },
  "gao_yao_xian": "ハイウエスト",
  "gao_yao_zhong_xian": "ハイウエスト中央線",
  "gao_yao_xia_xian": "ハイウエスト下部線",
  "xiao_yao_shang_xian": "ローウエスト上部線",
  "xiao_yao_zhong_xian": "ローウエスト中央線",
  "xiao_yao_xian": "ロウウエスト",
  "qv_jian1": "ハイウエスト上部",
  "qv_jian2": "ハイウエスト下部",
  "qv_jian_zhong": "ミドルウエスト部",
  "qv_jian3": "ローウエスト上部",
  "qv_jian4": "ローウエスト下部",
  "celiang.failed": "測定に失敗しました。体にフィットする服を着用し、動かないようにして再測定してください",
  "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "頭部前突/傾きと軽度の頸椎偏移があります。座り姿勢に注意しましょう。",
  "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "頭部前突/傾きと頸椎偏移があります。姿勢管理と筋トレを推奨します。",
  "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "顕著な頭部前突/傾きと頸椎偏移があります。専門家の評価と介入を推奨します。",
  "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "軽度の胸椎偏移があります。姿勢管理を強化しましょう。",
  "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "胸椎偏移が体幹の安定性に影響します。専門的なトレーニングを推奨します。",
  "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "顕著な胸椎偏移と非対称性があります。専門家の評価と姿勢管理を推奨します。",
  "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "軽度の腰椎偏移がありますが、バランスは保たれています。体幹トレーニングを推奨します。",
  "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "腰椎偏移が安定性に影響します。調整トレーニングを推奨します。",
  "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "顕著な腰椎偏移があります。専門家の評価と改善プランを推奨します。",
  "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "過緊張: 肩甲挙筋、胸鎖乳突筋、僧帽筋上部。 筋力低下: 頸部深屈筋。 安定化とリラックスを推奨します。",
  "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "過緊張: 左胸鎖乳突筋、後斜角筋。 筋力低下: 右胸鎖乳突筋。 左右バランス訓練とリラックスを推奨します。",
  "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "過緊張: 右胸鎖乳突筋。 筋力低下: 左胸鎖乳突筋、後斜角筋。 対称性訓練とリラックスを推奨します。",
  "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "過緊張: 左僧帽筋上部。 筋力低下: 僧帽筋中下部。 中下部の訓練と上部のリラックスを推奨します。",
  "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "過緊張: 股関節内旋筋、内転筋。 筋力低下: 中殿筋。 中殿筋訓練とストレッチを推奨します。",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "過緊張: 中殿筋、梨状筋。 筋力低下: 内転筋、内旋筋、LCL。 下肢の安定化と臀部のリラックスを推奨します。",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "過緊張: 中殿筋、梨状筋。 片側筋力低下: 内転筋、内旋筋、LCL。 左右バランストレーニングを推奨します。",
  "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "過緊張: 左ハムストリングス、膝窩筋。 筋力低下: 大腿四頭筋、ヒラメ筋。 四頭筋/ヒラメ筋訓練とストレッチを推奨します。",
  "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "過緊張: 左大腿四頭筋。 筋力低下: 大殿筋、ハムストリングス。 臀部/後面チェーン訓練とストレッチを推奨します。",
  "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "過緊張: 右ハムストリングス、膝窩筋。 筋力低下: 大腿四頭筋、ヒラメ筋。 四頭筋/ヒラメ筋訓練とストレッチを推奨します。",
  "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "過緊張: 右大腿四頭筋。 筋力低下: 大殿筋、ハムストリングス。 臀部/後面チェーン訓練とストレッチを推奨します。",
  "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "軽度の脊柱偏移。日常の姿勢に注意し、体幹を鍛えましょう。",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "中等度の脊柱偏移。専門家の指導によるトレーニングを推奨します。",
  "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "過緊張: 右僧帽筋上部。 筋力低下: 僧帽筋中下部。 中下部の訓練と上部のリラックスを推奨します。",
    ...ja,
    ...agrEn,
  "neckReport": {
  "title": "頸部機能",
  "conclusion": "首の機能評価結論",
  "loading": "レポートを作成しています。しばらくお待ちください。",
  "failed": "報告合成に失敗しました",
  "analysis": "分析",
  "suggestion": "提案",
  "suggestionText": "専門家に原因を詳しく調査し治療を受けましょう"
}
}
